import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Grid from '@mui/material/Grid';

const s:any = {
  grid: {
    minHeight: '100vh',
  },
};

class DynamicGrid extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  render() {
    const {xs,sm,md,lg,xl, children} = this.props;
    const xxs = xs || 12;
    const xsm = sm || 6; 
    const xmd = md || 4;
    const xlg = lg || 2; 
    const xxl = xl || 2;
    return (
      <Grid
        container
        spacing={{xs:0}}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{...s.grid}}
      >
        <Grid size={{xs:xxs,sm:xsm,md:xmd,lg:xlg,xl:xxl}}>
          {children}
        </Grid>   
      </Grid> 
    );
  }
}

DynamicGrid.propTypes = {
  //classes: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default DynamicGrid;
